export default "__VITE_ASSET__BOaiSxa___"